import React, {ReactNode} from 'react'
import styled from '@emotion/styled'
import {css} from '@emotion/core'
import {PlusIcon} from '../PlusIcon'

type ContentProps = {
  children: ReactNode
  /** Whether the tag displays with alternative curved borders */
  hasAlternateRadius?: boolean
}

const TagContainer = styled.span<Pick<ContentProps, 'hasAlternateRadius'>>(
  ({theme, hasAlternateRadius}) => css`
    display: inline-flex;
    padding: ${theme.layout.spacing.s200}px 6px;
    background-color: ${theme.colors.violet.v200};
    border-radius: ${hasAlternateRadius
      ? `${theme.layout.radius.lg}px 0`
      : theme.layout.radius.sm}px;
    gap: 4px;
    vertical-align: middle;
    align-items: center;
  `
)

const Text = styled.span(
  ({theme}) => css`
    ${theme.typography.text.tag};
    color: ${theme.colors.violet.v700};
  `
)

export const PlusTextTag = ({children, hasAlternateRadius}: ContentProps) => (
  <TagContainer hasAlternateRadius={hasAlternateRadius}>
    <PlusIcon translateY="0" variant="text" size="md" />
    <Text>{children}</Text>
  </TagContainer>
)

export default PlusTextTag
